export const ESPECIE_HOME_LOADING = 'ESPECIE_HOME_LOADING';
export const ESPECIE_HOME_LOADED = 'ESPECIE_HOME_LOADED';
export const ESPECIE_HOME_ERROR = 'ESPECIE_HOME_ERROR';

export const ESPECIE_PANEL_LOADING = 'ESPECIE_PANEL_LOADING';
export const ESPECIE_PANEL_LOADED = 'ESPECIE_PANEL_LOADED';
export const ESPECIE_PANEL_ERROR = 'ESPECIE_PANEL_ERROR';

export const ESPECIE_HOME_INDI_LOADING = 'ESPECIE_HOME_INDI_LOADING';
export const ESPECIE_HOME_INDI_LOADED = 'ESPECIE_HOME_INDI_LOADED';
export const ESPECIE_HOME_INDI_ERROR = 'ESPECIE_HOME_INDI_ERROR';

export const ESPECIE_DETALIS_INDI_LOADING = 'ESPECIE_DETALIS_INDI_LOADING';
export const ESPECIE_DETALIS_INDI_LOADED = 'ESPECIE_DETALIS_INDI_LOADED';
export const ESPECIE_DETALIS_INDI_ERROR = 'ESPECIE_DETALIS_INDI_ERROR';
